import { decodeString } from '../../../utils/commonUtils';
import { getValueWithDataType } from '../runtime.utils';

export const createChangesObj = (index, selection, entityDefinition, columns = []) => (
  changes,
  mapping
) => {
  const { updateTo, updateFrom } = mapping;
  const [entityName, fieldName] = updateTo.split('.');
  const targetColumn = columns.find((column) => column.accessor === updateFrom);
  const selectionColumn = !targetColumn?.translateData
    ? updateFrom
    : targetColumn.accessorUnTranslated;

  const selectionKey = selectionColumn || updateFrom;
  const value = decodeString(selection[selectionKey]);
  const entityType = Object.keys(entityDefinition)[0];

  const castedValue = getValueWithDataType(
    value,
    entityDefinition,
    entityType,
    entityName,
    fieldName
  );

  return [
    ...changes,
    {
      value: castedValue,
      entityName,
      fieldName,
      index,
    },
  ];
};
